// helpers.ts — Pure utility functions for D204 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Derive the status badge for a record */
export const getStatusBadge = (record: {
  fd140_80?: string;
} | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.fd140_80 || '').trim();
  // 統一狀態碼（規格法定值）：N=草稿/已沖銷、D=送審中、P=已核准
  // （自創碼 S/R/V 已廢除；S 保留映射僅供顯示殘留舊值）
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  if (s80 === 'D') return { text: '送審中', cls: 'badge-warning' };
  if (s80 === 'S') return { text: '送審中(舊碼)', cls: 'badge-warning' };
  return { text: '未送審', cls: 'badge-default' };
};

/** Check if record is locked for editing */
export const isLockedForEdit = (record: {
  fd140_80?: string;
} | null): boolean => {
  if (!record) return false;
  const s80 = (record.fd140_80 || '').trim();
  return ['P', 'D', 'S'].includes(s80); // 統一碼 D + 舊碼 S 過渡容忍
};

const ALWAYS_READONLY = new Set([
  'fd140_01', 'fd140_43', 'fd140_45', 'fd140_44',
  'fd140_16', 'fd140_161', 'fd140_17', 'fd140_19', 'fd140_21', 'fd140_35',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};

/** Approval status label map */
export const APPROVAL_STATUS: Record<string, string> = {
  N: '未送審',
  S: '送審中',
  P: '已核准',
  R: '已退回',
  '': '未送審',
};

/** Pricing method labels */
export const PRICING_METHOD: Record<number, string> = {
  1: '計量',
  2: '一缸',
};
